import fetch from './api'

// 获取批改任务列表
const GETCORRECTLIST = params => {
    return fetch({
        url: '/api/admin/correctlist/correctList',
        method: 'get',
        params: params
    })
}

// 领取OR取消批改任务
const RECEIVETASK = params => {
    return fetch({
        url: '/api/admin/correctlist/getCorrectTaskAjax',
        method: 'get',
        params: params
    })
}
// 获取任务详情
const GETTASKINFO = params => {
    return fetch({
        url: '/api/api/correctresult/getCorrectResult',
        method: 'get',
        params: params
    })
}
// 上传图片
const UPLOADIMAGE = params => {
    return fetch({
        type: 2,
        url: '/api/admin/library/uploadImg',
        method: 'POST',
        data: params
    })
}
// 获取基本搜索信息
const GETPARAMSOPTIONS = params => {
    return fetch({
        url: '/api/admin/correctlist/getBaseInfo',
        method: 'get',
        params: params
    })
}
// 添加教师点评
const ADDTEACHERREMARK = params => {
    return fetch({
        url: '/api/admin/correctremark/saveTeacherRemark',
        method: 'post',
        data: params
    })
}
// 查看教师点评
const GETTEACHERREMARK = params => {
    return fetch({
        url: '/api/admin/correctremark/getTeacherRemark',
        method: 'get',
        params: params
    })
}
// 修改教师点评
const EDITTEACHERREMARK = params => {
    return fetch({
        url: '/api/admin/correctremark/editTeacherRemark',
        method: 'post',
        data: params
    })
}
// 获取子任务id
const GETSUBJOBID = params => {
  return fetch({
      url: '/api/admin/correctlist/getSubJobId',
      method: 'get',
      params: params
  })
}
// 获取当前登录人批改说明阅读状态
const GETUSERCORRECTEXPLAIN = params => {
  return fetch({
      url: '/api/admin/correctremark/getUserCorrectExplain',
      method: 'get',
      params: params
  })
}
// 设置当前登录人批改说明阅读状态
const SETUSERCORRECTEXPLAIN = params => {
  return fetch({
      url: '/api/admin/correctremark/readCorrectExplain',
      method: 'get',
      params: params
  })
}
// 发布给学员
const PUBLISHJOB = params => {
  return fetch({
      url: '/api/admin/correctremark/publishJob',
      method: 'get',
      params: params
  })
}
// 获取某任务下已经批改过的试题id
const GETFINISHEDCORRECTQUESTIONIDS = params => {
  return fetch({
      url: '/api/admin/correctremark/getFinishedCorrectQuestionIds',
      method: 'get',
      params: params
  })
}
// 获取某任务下试题对应的学员答题卡
const GETQUESTIONANSWERSHEET = params => {
  return fetch({
      url: '/api/admin/correctremark/getQuestionAnswerSheet',
      method: 'get',
      params: params
  })
}


export default {
    GETCORRECTLIST,
    RECEIVETASK,
    GETTASKINFO,
    UPLOADIMAGE,
    GETPARAMSOPTIONS,
    ADDTEACHERREMARK,
    GETSUBJOBID,
    GETUSERCORRECTEXPLAIN,
    SETUSERCORRECTEXPLAIN,
    GETTEACHERREMARK,
    EDITTEACHERREMARK,
    PUBLISHJOB,
    GETFINISHEDCORRECTQUESTIONIDS,
    GETQUESTIONANSWERSHEET
}



// WEBPACK FOOTER //
// ./src/api/interface-task.js